import Vue from 'vue'
import VueTimeago from 'vue-timeago';
import VueMeta from 'vue-meta'
import VTooltip from 'v-tooltip';
import VModal from 'vue-js-modal'
import Index from '@/legacy/views/Index.vue'
import { navigate, router, delegate, resolve, redirect } from '@/legacy/router'
import 'normalize.css';

import '@/legacy/scss/vendor/bootstrap/bootstrap.scss';
import '@/legacy/scss/_theme.scss';
import '@/legacy/scss/helpers/_typography.scss';
import '@/legacy/scss/helpers/_util.scss';
import '@/legacy/scss/components/_form.scss';
import '@/legacy/scss/components/_misc.scss';
import '@/legacy/scss/_main.scss';
import '@/legacy/scss/_util.scss';
import '@/styles/main.scss';

Vue.config.productionTip = false;

Vue.mixin ({
  methods: {
    navigate,
    delegate,
    resolve,
    redirect
  }
});

Vue.use (VueMeta);
Vue.use (VModal);
Vue.use (VueTimeago, {});
Vue.use (VTooltip);

new Vue ({
  router,
  render: h => h (Index)
}).$mount ('#W3S');